import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, DownloadIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-28 pb-16 lg:pt-36 lg:pb-24 overflow-hidden bg-gradient-to-b from-sky-50 to-white" data-id="element-115">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center" data-id="element-116">
        {/* Left Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.7
      }} className="max-w-xl" data-id="element-117">
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-playfair font-bold text-slate-900 leading-tight mb-6" data-id="element-118">
            Why Your Teeth May Be Getting Worse — Even If You Brush Every Day
          </h1>

          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-119">
            Discover the little-known oral health insight that's helping
            thousands of Americans better understand the hidden connection
            between sugar, oral bacteria, and long-term dental wellness. Without
            expensive treatments, complicated routines, or harsh products.
          </p>

          <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-8 rounded-full transition-all transform hover:scale-105 shadow-lg w-full sm:w-auto text-lg mb-6" data-id="element-120">
            Get Instant Access Now
          </button>

          {/* Star rating */}
          <div className="flex items-center gap-2 mb-6" data-id="element-121">
            <div className="flex" data-id="element-122">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} className="fill-orange-400 text-orange-400" data-id="element-123" />)}
            </div>
            <span className="text-sm text-slate-600 font-medium" data-id="element-124">
              Rated by Thousands of Readers
            </span>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap gap-x-6 gap-y-3 text-sm text-slate-600" data-id="element-125">
            <div className="flex items-center" data-id="element-126">
              <DownloadIcon size={16} className="text-sky-500 mr-2" data-id="element-127" />
              <span data-id="element-128">Instant Download</span>
            </div>
            <div className="flex items-center" data-id="element-129">
              <LockIcon size={16} className="text-sky-500 mr-2" data-id="element-130" />
              <span data-id="element-131">Secure Checkout</span>
            </div>
            <div className="flex items-center" data-id="element-132">
              <ShieldCheckIcon size={16} className="text-sky-500 mr-2" data-id="element-133" />
              <span data-id="element-134">60-Day Guarantee</span>
            </div>
          </div>
        </motion.div>

        {/* Right Content - Smiling woman + ebook */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative flex justify-center items-center" data-id="element-135">
          {/* Soft background circle */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-136">
            <div className="w-[90%] aspect-square bg-sky-100 rounded-full blur-2xl opacity-60" data-id="element-137" />
          </div>

          {/* Smiling woman photo */}
          <div className="relative w-full max-w-md aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl border-8 border-white" data-id="element-138">
            <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&h=1000&fit=crop" alt="Woman smiling confidently" className="w-full h-full object-cover" data-id="element-139" />
          </div>

          {/* eBook mockup floating */}
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="absolute -right-2 sm:-right-6 lg:-right-12 bottom-0 sm:bottom-4 w-32 sm:w-40 lg:w-48 aspect-[3/4] rounded-lg shadow-2xl overflow-hidden border-l-4 border-sky-600 transform rotate-6" data-id="element-140">
            <img src="https://cdn.magicpatterns.com/uploads/4N6DPdPYME5x1S7QhhQ6Ch/heylloyd-image-1780001569319.png" alt="The Dental Sugar Hack digital guide" className="w-full h-full object-cover" data-id="element-141" />
          </motion.div>

          {/* Floating "60-Day" badge */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.7,
          type: 'spring'
        }} className="absolute -top-2 -left-2 sm:-top-4 sm:-left-4 w-20 h-20 sm:w-24 sm:h-24 bg-orange-500 rounded-full flex flex-col items-center justify-center text-white shadow-xl border-4 border-white" data-id="element-142">
            <span className="font-playfair font-bold text-lg sm:text-xl leading-none" data-id="element-143">
              60
            </span>
            <span className="text-[9px] sm:text-[10px] font-bold uppercase tracking-wider mt-1" data-id="element-144">
              Day
            </span>
            <span className="text-[8px] sm:text-[9px] uppercase tracking-wide" data-id="element-145">
              Guarantee
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}